"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FormWrapper = _interopRequireDefault(require("../FormWrapper"));
var _cccisdLaravelNexus = require("cccisd-laravel-nexus");
var _queryVariablesHelper = _interopRequireDefault(require("../../helpers/queryVariablesHelper.js"));
var _rowActionsHelper = _interopRequireDefault(require("../../helpers/rowActionsHelper.js"));
var _setAppdefEnumFilterSettings = _interopRequireDefault(require("../../helpers/setAppdefEnumFilterSettings.js"));
var _cccisdTabletop = _interopRequireDefault(require("cccisd-tabletop"));
var _cccisdTableRenders = _interopRequireDefault(require("cccisd-table-renders"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _Buttons = _interopRequireDefault(require("../Buttons"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import { LicenseRowAction } from 'cccisd-laravel-licensing';
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var rendersContext = require.context('resources/assets/js', true, /^\.\/renders\/([^/]+\/){1}index\.js$/);
var buttonsContext = require.context('resources/assets/js', true, /^\.\/vendor\/app-definitions\/tableButtons\/([^/]+\/){1}index\.js$/);
var RosteringContainer = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(RosteringContainer, _React$Component);
  function RosteringContainer() {
    var _this;
    _classCallCheck(this, RosteringContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RosteringContainer, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "afterFormSubmit", function () {
      // reload data
      _this.tt.loadData();
      if (_this.props.externalLoadData) {
        _this.props.externalLoadData();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getRenderFromContext", function (context, type) {
      if (!context) {
        return function () {};
      }
      var foundKey = (0, _find2["default"])(context.keys(), function (key) {
        var renderType = key.replace(/^.*\/[^/]+\/([^/]+)\/index\.js$/, '$1');
        return type === renderType;
      });
      if (foundKey) {
        return context(foundKey);
      }
      console.warn("App renderer not found for \"".concat(type, "\" in app"));
      return undefined;
    });
    _defineProperty(_assertThisInitialized(_this), "getButtonsFromContext", function (context, handle) {
      if (!context) {
        return function () {};
      }
      var foundKey = (0, _find2["default"])(context.keys(), function (key) {
        var buttonHandle = key.replace(/^.*\/[^/]+\/([^/]+)\/index\.js$/, '$1');
        return handle === buttonHandle;
      });
      if (foundKey) {
        return context(foundKey);
      }
      console.warn("App table button not found for \"".concat(handle, "\" in app"));
      return undefined;
    });
    _defineProperty(_assertThisInitialized(_this), "processTable", function (view) {
      var _this$props = _this.props,
        _this$props$content = _this$props.content,
        form = _this$props$content.form,
        routes = _this$props$content.routes,
        type = _this$props$content.type,
        nexusType = _this$props$content.nexusType,
        externalLoadData = _this$props.externalLoadData;
      var cols = [];
      view.table.columns.forEach(function (c) {
        var column = {};
        if ('renderAs' in c) {
          if (c.renderAs.type === 'RosteringButtons') {
            var settings = c.renderAs.settings;
            settings.FormComponent = _FormWrapper["default"];
            settings.formProps = {
              type: type,
              routes: routes,
              form: form,
              afterFormSubmit: _this.afterFormSubmit,
              nexusType: nexusType
            };
            column.render = (0, _cccisdLaravelNexus.RosteringButtons)(settings);
          } else if (c.renderAs.type === 'UnarchiveButton') {
            column.render = (0, _cccisdLaravelNexus.UnarchiveButton)(c.renderAs.settings);
          } else {
            var tmpRender;
            var renderClass = function renderClass() {};
            if (c.renderAs["class"] === 'app') {
              tmpRender = _this.getRenderFromContext(rendersContext, c.renderAs.type);
              if (!(0, _isUndefined2["default"])(tmpRender)) {
                renderClass = tmpRender["default"];
              }
            } else {
              renderClass = _cccisdTableRenders["default"][c.renderAs["class"]][c.renderAs.type];
            }
            column.render = renderClass(c.renderAs.settings);
            column = Object.assign(column, (0, _setAppdefEnumFilterSettings["default"])(c, column));
          }
        }
        cols.push(Object.assign(c, column));
      });
      var variables = {};
      if ('requiredVariables' in view.table) {
        variables = (0, _queryVariablesHelper["default"])(view.table.requiredVariables);
      }
      if (view.table.rowActions) {
        view.table.rowActions = (0, _rowActionsHelper["default"])(view.table.rowActions, externalLoadData);
      }
      return Object.assign((0, _omit2["default"])(view.table, ['columns', 'requiredVariables']), {
        columns: cols,
        graphqlVariables: variables
      });
    });
    _defineProperty(_assertThisInitialized(_this), "processBottomTable", function (view) {
      var externalLoadData = _this.props.externalLoadData;
      var bottomCols = [];
      view.bottomTable.columns.forEach(function (bc) {
        var bcolumn = {};
        if ('renderAs' in bc) {
          if (bc.renderAs.type === 'RosteringButtons') {
            bcolumn.render = (0, _cccisdLaravelNexus.RosteringButtons)(bc.renderAs.settings);
          } else if (bc.renderAs.type === 'UnarchiveButton') {
            bcolumn.render = (0, _cccisdLaravelNexus.UnarchiveButton)(bc.renderAs.settings);
          } else {
            var tmpRender;
            var renderClass = function renderClass() {};
            if (bc.renderAs["class"] === 'app') {
              tmpRender = _this.getRenderFromContext(rendersContext, bc.renderAs.type);
              if (!(0, _isUndefined2["default"])(tmpRender)) {
                renderClass = tmpRender["default"];
              }
            } else {
              renderClass = _cccisdTableRenders["default"][bc.renderAs["class"]][bc.renderAs.type];
            }
            bcolumn.render = renderClass(bc.renderAs.settings);
            bcolumn = Object.assign(bcolumn, (0, _setAppdefEnumFilterSettings["default"])(bc, bcolumn));
          }
        }
        bottomCols.push(Object.assign(bc, bcolumn));
      });
      var variables = {};
      if ('requiredVariables' in view.bottomTable) {
        variables = (0, _queryVariablesHelper["default"])(view.bottomTable.requiredVariables);
      }
      if (view.bottomTable.rowActions) {
        view.bottomTable.rowActions = (0, _rowActionsHelper["default"])(view.bottomTable.rowActions, externalLoadData);
      }
      return Object.assign((0, _omit2["default"])(view.bottomTable, ['columns']), {
        columns: bottomCols,
        graphqlVariables: variables
      });
    });
    _defineProperty(_assertThisInitialized(_this), "processProps", function () {
      var _this$props2 = _this.props,
        tabHandle = _this$props2.tabHandle,
        products = _this$props2.products,
        _this$props2$content = _this$props2.content,
        tableTop = _this$props2$content.tableTop,
        form = _this$props2$content.form,
        routes = _this$props2$content.routes,
        type = _this$props2$content.type,
        nexusType = _this$props2$content.nexusType,
        externalLoadData = _this$props2.externalLoadData;
      var tableTopProps = tableTop;
      if (products && products.length && !tableTopProps.views.some(function (view) {
        return view.table.columns.some(function (v) {
          return v.handle === 'license';
        });
      })) {
        var manageViewIndex = tableTopProps.views.findIndex(function (v) {
          return v.handle === 'manage';
        });
        if (manageViewIndex === -1) {
          manageViewIndex = 0;
        }
        var manageView = tableTopProps.views[manageViewIndex];
        if (manageView) {
          var _tableTopProps$views;
          var manageViews = [];
          products.forEach(function (product) {
            var productId = product.productId,
              handle = product.handle,
              label = product.label,
              duration = product.duration;

            // we're modifying some nested keys, so safer to deep copy
            var viewPerProduct = (0, _cloneDeep2["default"])(manageView);
            viewPerProduct.handle += product.productId;
            viewPerProduct.title = product.label;
            viewPerProduct.productId = productId;
            viewPerProduct.productHandle = handle;
            var existingVariables = (0, _get2["default"])(viewPerProduct, 'table.requiredVariables', []) || [];
            viewPerProduct.table.requiredVariables = [].concat(_toConsumableArray(existingVariables), [{
              variable: 'productId',
              value: productId
            }]);

            // * The following block concerning Bulk License Assignment via Row Action
            // * has been temporaily disabled until the corresponding backend route(s)
            // * are completed.
            // TODO: RE-ENABLE WHEN COMPLETED

            // const existingRowActions = _get(viewPerProduct, 'table.rowActions', []) || [];
            // if (!existingRowActions.some(rAction => rAction.action === 'license') && nexusType === 'pawn') {
            //     viewPerProduct.table.rowActions = [
            //         ...existingRowActions,
            //         {
            //             ...LicenseRowAction,
            //             title: 'Assign License: ' + label,
            //             component: rowActionProps => (
            //                 <LicenseRowAction.component {...rowActionProps} {...product} />
            //             ),
            //         },
            //     ];
            // }

            var actionsColumnIndex = viewPerProduct.table.columns.findIndex(function (col) {
              return col.handle === 'actions' || col.renderAs && col.renderAs.type === 'RosteringButtons';
            });
            if (nexusType === 'pawn') {
              viewPerProduct.table.columns.splice(actionsColumnIndex + 1, 0, {
                handle: 'license',
                label: 'License',
                name: 'ownedLicenseList',
                renderAs: {
                  "class": 'string',
                  settings: {
                    productId: productId
                  },
                  type: 'LicenseStatus'
                },
                filter: true,
                filterSettings: {
                  type: 'selectbox',
                  field: 'licenseStatus',
                  options: [{
                    label: 'None',
                    value: 'none'
                  }, {
                    label: 'Active',
                    value: 'active'
                  }, {
                    label: 'Expired',
                    value: 'expired'
                  }]
                }
              });
            }
            if (nexusType === 'group') {
              viewPerProduct.table.columns.splice(actionsColumnIndex + 1, 0, {
                handle: 'license',
                label: 'Available Licenses',
                name: 'availableLicenseCount',
                filter: false,
                sort: true,
                className: 'text-center',
                // custom render to make it more developer friendly
                // in case they forgot to update the manage queries
                render: function render(_ref) {
                  var value = _ref.value,
                    row = _ref.row;
                  if (!('availableLicenseCount' in row)) {
                    console.error('Must add variable `$productId` and field ' + '`availableLicenseCount` to this graphql query');
                  }
                  return !value && value !== 0 ? '-' : value;
                }
              });

              // we don't want default sort to be Available Licenses
              if (!viewPerProduct.table.orderBy) {
                var defaultSort = viewPerProduct.table.columns.find(function (col) {
                  return col.sort && col.handle !== 'license';
                });
                viewPerProduct.table.orderBy = defaultSort ? defaultSort.name : '';
              }
            }
            if (actionsColumnIndex !== -1) {
              viewPerProduct.table.columns[actionsColumnIndex].renderAs.settings.buttons.push(nexusType === 'pawn' ? {
                type: 'pawnLicensing',
                settings: {
                  productId: productId,
                  label: label,
                  duration: duration
                }
              } : {
                type: 'groupLicensing',
                settings: {
                  products: [product],
                  isActionButton: true
                }
              });
            }
            manageViews.push(viewPerProduct);
          });
          (_tableTopProps$views = tableTopProps.views).splice.apply(_tableTopProps$views, [manageViewIndex, 1].concat(manageViews));
        }
      }
      var views = [];
      tableTopProps.views.forEach(function (view) {
        var newView = (0, _omit2["default"])(view, ['table', 'bottomTable']);

        // columns
        var table = _this.processTable(view);
        if ('bottomTable' in view) {
          var bottomTable = _this.processBottomTable(view);
          newView.bottomTable = Object.assign((0, _omit2["default"])(view.bottomTable, ['columns']), bottomTable);
        }

        // buttons
        var buttons = [];
        if (!('hideAddButton' in _this.props.content) || 'hideAddButton' in _this.props.content && !_this.props.content.hideAddButton) {
          // If the view is for a product, need CreateButton to be aware of the productId
          var createButtonForm = (0, _cloneDeep2["default"])(form);
          if (view.productId && 'create' in createButtonForm.graphql) {
            var productIdVariable = {
              variable: 'productId',
              value: view.productId
            };
            createButtonForm.graphql.create.requiredVariables = [].concat(_toConsumableArray(createButtonForm.graphql.create.requiredVariables || []), [productIdVariable]);
          }
          buttons.push(function (_ref2) {
            var loadData = _ref2.loadData;
            return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelNexus.CreateButton, {
              FormComponent: _FormWrapper["default"],
              formProps: {
                form: createButtonForm,
                type: type,
                routes: routes,
                afterFormSubmit: _this.afterFormSubmit
              },
              settings: {
                className: 'btn btn-primary',
                buttonText: "Add ".concat(type),
                modalTitle: "Add New ".concat(type)
              },
              withIcon: true
            });
          });
        }
        if ('bulkHandle' in _this.props.content) {
          var bulkButtonText = "Bulk Add ".concat(type);
          if ('bulkButtonText' in _this.props.content) {
            bulkButtonText = _this.props.content.bulkButtonText;
          }
          buttons.push(function (_ref3) {
            var loadData = _ref3.loadData;
            var loadAllData = function loadAllData() {
              loadData();
              if (externalLoadData) {
                externalLoadData();
              }
            };
            return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelNexus.BulkUploader, {
              handle: _this.props.content.bulkHandle,
              trigger: /*#__PURE__*/_react["default"].createElement("button", {
                type: "button",
                className: "btn btn-primary"
              }, bulkButtonText),
              loadData: loadAllData
            });
          });
        }
        if ('selfRosterLinkButton' in _this.props.content && _this.props.content.nexusType === 'pawn') {
          var redirectPath = _this.props.content.selfRosterLinkButton.redirectPath || '';
          var redirectUrl = null;
          if (redirectPath) {
            redirectUrl = Boilerplate.url(redirectPath);
          }
          buttons.push(function (_ref4) {
            var loadData = _ref4.loadData;
            return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelNexus.SelfRosterLinkButton, _extends({
              role: type,
              roleHandle: tabHandle,
              product: {
                label: view.title,
                handle: view.productHandle
              }
            }, _this.props.content.selfRosterLinkButton, {
              redirectUrl: redirectUrl
            }));
          });
        }
        if ('buttons' in view) {
          view.buttons.forEach(function (b) {
            var Button;
            if ('componentHandle' in b) {
              var tmpButton = _this.getButtonsFromContext(buttonsContext, b.componentHandle);
              if (!(0, _isUndefined2["default"])(tmpButton)) {
                Button = tmpButton["default"];
              }
            } else {
              Button = _Buttons["default"][b.name];
            }
            buttons.push(function (_ref5) {
              var loadData = _ref5.loadData;
              var loadAllData = function loadAllData() {
                loadData();
                if (externalLoadData) {
                  externalLoadData();
                }
              };
              return /*#__PURE__*/_react["default"].createElement(Button, {
                settings: b.settings,
                loadData: loadAllData
              });
            });
          });
        }
        if ('tableDescription' in view) {
          newView.tableDescription = view.tableDescription;
        }
        newView.buttons = buttons;
        newView.table = Object.assign((0, _omit2["default"])(view.table, ['columns']), table);
        views.push(newView);
      });
      return {
        views: views,
        handle: tableTopProps.handle,
        saveState: tableTopProps.saveState
      };
    });
    return _this;
  }
  _createClass(RosteringContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdTabletop["default"], _extends({
        ref: function ref(input) {
          _this2.tt = input;
        }
      }, this.processProps(), {
        externalLoadData: this.props.externalLoadData
      })));
    }
  }]);
  return RosteringContainer;
}(_react["default"].Component);
_defineProperty(RosteringContainer, "propTypes", {
  /**
   * content json for view
   */
  tabHandle: _propTypes["default"].string,
  content: _propTypes["default"].object.isRequired,
  externalLoadData: _propTypes["default"].func,
  products: _propTypes["default"].array
});